module.exports = __webpack_public_path__ + "img/cgtg-ic.993d115f.png";